var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "40px",
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Folder icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quote-Form",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Approved---Quote---Desktop",
    transform: "translate(-383.000000, -3441.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(373.000000, 3378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(10.000000, 63.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Foler-circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,0 C31.8218374,0 41,8.954305 41,20 C41,31.045695 31.8218374,40 20.5,40 C9.17816263,40 0,31.045695 0,20 C0,8.954305 9.17816263,0 20.5,0 Z M20.5,2.66666667 C10.6877409,2.66666667 2.73333333,10.4270643 2.73333333,20 C2.73333333,29.5729357 10.6877409,37.3333333 20.5,37.3333333 C30.3122591,37.3333333 38.2666667,29.5729357 38.2666667,20 C38.2516152,10.4331534 30.3060178,2.68135103 20.5,2.66666667 Z M8.85227273,11.6883116 L8.85227273,28.3116885 C8.85227273,28.7196624 9.23062532,29.0909091 9.64643595,29.0909091 L31.353564,29.0909091 C31.7693747,29.0909091 32.1477273,28.7196624 32.1477273,28.3116885 L32.1477273,15.3246741 C32.1477273,14.9167002 31.7693747,14.5455055 31.353564,14.5454536 L21.4182512,14.5454536 L18.7379503,11.2012987 C18.589651,11.0195845 18.3547745,10.9090909 18.1175103,10.9090909 L9.64643595,10.9090909 C9.21894848,10.9184417 8.8609794,11.359948 8.85227273,11.6883116 L8.85227273,11.6883116 Z M10.6580591,12.7988994 L17.451841,12.7988994 L20.1238694,16.1349503 C20.2705143,16.3196256 20.505711,16.4334697 20.7443094,16.4352619 L30.2687816,16.4352619 L30.2687816,27.2697654 L10.6580591,27.2697654 L10.6580591,12.7988994 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderCircle);
export default __webpack_public_path__ + "static/media/folder-circle.1fa4eb19d6574bf806de6f377840c02a.svg";
export { ForwardRef as ReactComponent };